import { apiFetch } from "../Api/apiFetch";
import { broadcast } from "../WebSocket/picoBroadcastChannel";
import { clearPendingMutations } from "../Offline/pendingMutationsDb";

interface LogoutConfig {
  picoComApiUrl: string;
  onPostLogout: () => void;
}

let config: LogoutConfig | null = null;

export function configureLogout(cfg: LogoutConfig): void {
  config = cfg;
}

export async function logout(): Promise<void> {
  if (!config) {
    throw new Error("logout() called before configureLogout()");
  }
  try {
    await apiFetch(`${config.picoComApiUrl}/auth/logout`, { method: "POST" });
  } catch {
    // ignore — still clear local state
  }
  await clearPendingMutations();
  broadcast({ type: "USER_LOGOUT" });
  config.onPostLogout();
}
